import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, HostBinding, Input, OnChanges, OnInit, inject, signal,
} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import {
  NavigationEnd, Router,
} from '@angular/router'
import { iconArrowRight } from '@knorr-bremse-portals/icons'
import {
  PlainLink, RouterOrExternalLinkDirective,
} from '@knorr-bremse-portals/ngx-components'
import {
  NavigationItem, NavigationLevel, SiteNavigationIntl, getActiveNavigation, normalizeToPath,
} from '@knorr-bremse-portals/ngx-components/components/header'
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon'
import { filter } from 'rxjs'

@Component({
  selector: 'nav[kb-breadcrumb-navigation]',
  imports: [RouterOrExternalLinkDirective, IconComponent],
  templateUrl: `./breadcrumb-navigation.component.html`,
  styleUrl: './breadcrumb-navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbNavigationComponent implements OnChanges, OnInit {
  @HostBinding('attr.aria-label') private label = 'Breadcrumb Navigation'
  @HostBinding('attr.kb-section') private section = ''

  @Input({ required: true }) public navigation!: NavigationLevel
  @Input({ required: true }) public homeLink!: PlainLink

  protected iconSeparator = iconArrowRight

  protected activeNavigation: NavigationItem[] = []

  private destroyRef = inject(DestroyRef)
  private router = inject(Router)
  protected currentUrl = signal(this.router.url)

  private cdr = inject(ChangeDetectorRef)
  protected intl = inject(SiteNavigationIntl)

  public constructor() {
    this.intl.changes$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.cdr.markForCheck())
  }

  public ngOnInit(): void {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((event) => {
      this.currentUrl.set(normalizeToPath(event.urlAfterRedirects))
      this.updateActiveNavigation()
    })
  }

  public ngOnChanges(): void {
    this.updateActiveNavigation()
  }

  private updateActiveNavigation() {
    this.activeNavigation = getActiveNavigation(this.navigation, this.currentUrl()).navigation
  }
}
